export default {
  entity: {
    id: null,
    name: 'Name',
    lastName: 'LastName',
    apiToken: '',
    loaded: false
  }
}